import { Component, Input, OnInit } from '@angular/core';
import { InvoiceStatus, TaskInvoiceInterface } from '@contracts/interfaces/invoice.interface';
import { InvoiceComponent } from '../invoice';


@Component({
  selector: 'app-invoice-task',
  templateUrl: './invoice-task.component.html',
  styleUrls: ['./invoice-task.component.scss', '../../pages/invoice-table.scss']
})
export class InvoiceTaskComponent extends InvoiceComponent implements OnInit {
  @Input() 
  invoice: TaskInvoiceInterface;

  defaultInvoice = {
    type: "task",
    status: InvoiceStatus.Unpaid,
    customer: null,
    number: null,
    custom: "",
    dateCreated: new Date(),
    dateDue: new Date(),
    subTotal: 0,
    total: 0,
    paymentsMade: [],
    taskID: null,
    pdf: {
      file: "invoice-task"
    },
    lineItems: [
      {
        item: '',
        desc: '',
        qty: 1,
        price: 0
      }
    ],
    gst: 0,
    isGSTIncluded: true,
    communicationLog: []
  }
}
